const states = new Map();
const subscribers = new Map();
export const getState = (group) => states.get(group);
export function setState(group, state) {
  if (!group || !state?.variant) return;
  const snapshot = { ...state, group, productId: String(state.productId) };
  states.set(group, snapshot);
  for (const callback of subscribers.get(group) || []) callback(snapshot);
  globalThis.document?.dispatchEvent(
    new CustomEvent('aura:variant-change', {
      detail: { group, productId: snapshot.productId, variant: snapshot.variant },
    }),
  );
  return snapshot;
}
export function subscribe(group, callback) {
  if (!subscribers.has(group)) subscribers.set(group, new Set());
  subscribers.get(group).add(callback);
  return () => {
    const listeners = subscribers.get(group);
    listeners?.delete(callback);
    if (!listeners?.size) subscribers.delete(group);
  };
}
